import {
  LayoutNodeActionType,
  LayoutNodeType,
} from "@towersystems/roam-common/lib/generated-types";
import {
  ItemConfigType,
  itemToNodeType,
  itemToTypeListItem,
} from "../../../../utilities/layout";
import { LayoutScreens } from "../../../../utilities/layout/constants";

export function configToEditNavigationArgs(config: ItemConfigType) {
  const typeListItem = itemToTypeListItem(config);
  const nodeType = itemToNodeType(config);

  switch (nodeType) {
    case LayoutNodeType.PRODUCT:
      return {
        screen: LayoutScreens.EditProductQuickScreen,
      };
    case LayoutNodeType.ACTION: {
      if (typeListItem === LayoutNodeActionType.CUSTOM_URL) {
        return { screen: LayoutScreens.CreateCustomUrlQuickKeyScreen };
      }
      throw Error("No screen found for action type: " + typeListItem);
    }
    case LayoutNodeType.FILTER: {
      return {
        screen: LayoutScreens.EditFilterQuickKeyRootScreen,
        params: { filter: typeListItem },
      };
    }
  }
}
